
import { Request } from "./request";

export interface Medical {
    id?: number;
    urbanName?: string;
    cautionTotal?: number;
    handleTotal?: number;
    organizationTotal?: string;
    medicalTotal?: string;

}
export interface MedicalParams {
    id?: any;
    scope?: number
}


export function getMedicalMessage(params: MedicalParams): Request {
    return {
        url: `/api/analysis/area/index`,
        method: "GET",
        params,
    }
}



